import { render, staticRenderFns } from "./IconNeutral.vue?vue&type=template&id=75c4bf0a&"
import script from "./IconNeutral.vue?vue&type=script&lang=ts&"
export * from "./IconNeutral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports